import React, { FC } from 'react';
import styled from 'styled-components';

import { TeamGamePlayerDisplay } from '../../../../database.schema';

const Table = styled.table`
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  color: white;
  background: transparent;
  font-size: 1rem;
  margin: 0 0.5rem;
`;

const TableHeader = styled.th`
  text-align: center;
  color: black;
  font-weight: bold;
`;

const TableCell = styled.td`
  text-align: center;
  padding: 0.25rem 0 0;
`;

export const TableRowBorder = styled.tr<{ colour?: string | null }>`
  color: ${(props) => props.colour || 'black'};
  font-weight: bold;
`;

type PlayerInfoProps = {
  teams: Array<TeamGamePlayerDisplay>;
};

export const TeamGamePlayerInfo: FC<PlayerInfoProps> = ({ teams }): JSX.Element => {
  return (
    <div>
      <Table data-testid="scorecard-handicap-table">
        <thead>
          <tr>
            <TableHeader></TableHeader>
            <TableHeader>Player</TableHeader>
            <TableHeader>Handicap</TableHeader>
          </tr>
        </thead>
        <tbody>
          {teams.map((player: TeamGamePlayerDisplay, index: number) => (
            <TableRowBorder colour="blue" key={`hcaps-t1-${player.nickName}`} data-testid={`t1-hcaps-${player.nickName}`}>
              <TableCell>{`P${index + 1}`}</TableCell>
              <TableCell>{player.nickName}</TableCell>
              <TableCell>{player.round.individualHandicap}</TableCell>
            </TableRowBorder>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
